import { makeStyles } from '@material-ui/core/styles';

const SidebarMenuUseStyles = makeStyles(theme => ({
  SidebarMenu: {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    position: 'fixed',
    top: 5,
    left: '50%',
    transform: 'translateX(-50%)',
    '&__nav': {
      position: 'relative',
      minWidth: 450,
      height: 44,
      backgroundColor: 'rgba(11, 17, 32, 0.85)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      border: '1px solid rgba(14, 165, 233, 0.12)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      '&__list': {
        position: 'relative',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 5,
        '&__item': {
          position: 'relative',
          fontWeight: 500,
          padding: '5px 15px',
          textAlign: 'center',
          width: '100%',
          '&__hr': {
            width: 1,
            height: 24,
            borderLeft: '1px solid rgba(148, 163, 184, 0.2)',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            '&--left': {
              marginLeft: -15,
            },
            '&--right': {
              marginLeft: 60,
            },
          },
          '&__box': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            '&__icon': {
              color: theme.palette.white,
              opacity: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.3rem',
              height: 36,
              lineHeight: '0.75px',
              borderRadius: '6px',
              transition: 'opacity 0.2s ease, background-color 0.2s ease',
              width: 36,
              zIndex: 4,
            },
            '&__text': {
              position: 'absolute',
              color: theme.palette.white,
              fontWeight: 500,
              fontSize: '0.6rem',
              opacity: 0,
              padding: 3,
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              transition: 'opacity 0.2s ease',
              zIndex: 5,
              bottom: -12,
            },
          },
          '&:hover': {
            cursor: 'pointer',
          },
          '&:hover &__box__icon, &.active:hover &__box__icon': {
            opacity: 1,
            backgroundColor: 'rgba(6, 182, 212, 0.15)',
            color: '#06B6D4',
          },
          '&:hover &__box__text, &.active:hover &__box__text': {
            opacity: 1,
          },
          '&.active &__box__icon': {
            color: '#06B6D4',
            opacity: 1,
          },
          '&.active &__box__text': {},
        },
      },
    },
  },
}));

export { SidebarMenuUseStyles };
